import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DeleteConfirmationParams} from '../../../types/confirmation-modal.types';
import {MatButton} from "@angular/material/button";
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {baseConfirmModalName} from "./configs/base-confirm-config";

@Component({
  selector: 'app-base-confirm-modal',
  standalone: true,
  imports: [
    MatButton,
    BaseModalComponent
  ],
  templateUrl: './base-confirm-modal.component.html',
  styleUrl: './base-confirm-modal.component.scss'
})
export class BaseConfirmModalComponent extends BaseModalComponent {
  private data = inject<{ deleteConfirmationParams: DeleteConfirmationParams }>(MAT_DIALOG_DATA);

  public titleText: string = '';
  public description: string = '';
  public buttonWarmText: string = '';
  public buttonPrimaryText: string = '';

  public override ngOnInit(): void {
    this.initDialogTexts();
    this.modalStatesService.openModal(baseConfirmModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(baseConfirmModalName);
  }

  private initDialogTexts(): void {
    const { titleText, description, buttonWarmText, buttonPrimaryText } = this.data.deleteConfirmationParams;
    this.titleText = titleText;
    this.description = description;
    this.buttonWarmText = buttonWarmText;
    this.buttonPrimaryText = buttonPrimaryText;
  }
}
